import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import { NodeSelection } from "@repo/fika-blog/src/tiptap/pm/state"
import { createEditorTransaction } from "solid-tiptap"
import { Mini } from "@/designSystem/components/mini/mini"
import { Tooltip } from "@/designSystem/components/tooltip"
import { DeleteButton, ParentButton } from "@/designSystem/patterns/editor-menu"

type Props = {
  editor: Editor
}

export function ListMenu(props: Props) {
  const isBulletList = createEditorTransaction(
    () => props.editor,
    editor => editor.isActive("bulletList"),
  )

  const isOrderedList = createEditorTransaction(
    () => props.editor,
    editor => editor.isActive("orderedList"),
  )

  const currentListType = () => {
    if (isBulletList()) return "bullet"
    if (isOrderedList()) return "ordered"
    return "bullet"
  }

  return (
    <Mini.Menu>
      <Mini.Section>
        <ParentButton editor={props.editor} />
      </Mini.Section>
      <Mini.Section>
        <Tooltip label="list type">
          <Mini.Select
            items={[
              { value: "bullet", label: "bullet", iconName: "list" },
              { value: "ordered", label: "ordered", iconName: "list-ordered" },
            ]}
            value={currentListType()}
            hideValue
            onChange={value => {
              if (!value) return
              const targetType =
                value === "bullet" ? "bulletList" : "orderedList"

              props.editor
                .chain()
                .focus()
                .command(({ tr }) => {
                  const { selection } = tr
                  const { from } = selection
                  tr.setNodeMarkup(from, props.editor.schema.nodes[targetType])
                  tr.setSelection(NodeSelection.create(tr.doc, from))
                  return true
                })
                .run()
            }}
          />
        </Tooltip>
      </Mini.Section>
      <Mini.Section>
        <DeleteButton editor={props.editor} />
      </Mini.Section>
    </Mini.Menu>
  )
}
